import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterContentInit, Component, ElementRef, EventEmitter, Input, NO_ERRORS_SCHEMA, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { AutoFocusDirective } from '../../directives/auto-focus.directive';
import { LoggerService } from '../../shared/logger.service';
import { SettingsService } from '../../settings/settings.service';
import { FocusService } from '../../shared/focus.service';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'casi-import-csv',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    LayoutModule,
    AutoFocusDirective
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './import-csv.component.html',
  styleUrl: './import-csv.component.scss'
})
export class ImportCsvComponent implements OnInit, OnDestroy, AfterContentInit {

  // @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();
  @Output() closeForm: EventEmitter<void> = new EventEmitter();

  // private _fileContent = new BehaviorSubject<string>('Nothing loaded yet');
  // public get fileContent() {
  //   return this._fileContent.getValue();
  // }
  // set fileContent(val: string) {
  //   this.logger.debug(`set:fileConent:val: `, val);
  //   this._fileContent.next(val);
  // }

  // @ViewChild('content') contentEl!: ElementRef;
  form: FormGroup;

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    private fb: FormBuilder,
    private settings: SettingsService,
    private focusService: FocusService,
    private scroller: ViewportScroller
  ) {
    this.form = this.fb.group({
      fileContent: [null, []]
    })
  }

  //#region Form properties

  get f() {
    return this.form.controls;
  }
  get fileContent() {
    return this.form.get('fileContent');
  }

  //#endregion

  //#region NG Event Handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...',);
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
    // this.scroller.scrollToPosition([10, 10]);
    // setTimeout(() => {
    //   // document.body.scrollTo({ top: 0, behavior: 'smooth' });
    //   this.scroller.scrollToPosition([0, 0]);
    //   // this.pForm.nativeElement.scrollTop();
    // }, 50);
  }

  //#endregion

  closeWindow(): void {
    this.logger.debug(`closeWindow...`);
    this.closeForm.emit();
  }

  async openFile() {
    this.logger.debug('openFile...');
    let that = this;
    let lastDir = this.settings.appDir;
    // window.electronAPI.openCsvFile({ cwd: lastDir })
    //   .then(filePath => this.logger.debug('open: filePath: ', filePath))
    //   .catch(err => this.logger.error(`openCsvFile:error: `, err.message));
    // // this.logger.debug(`openFile: filePath: `, filePath);

    // window.electronAPI.onGotCsvFiles((value: any) => {
    //   this.logger.debug(`on-got-csv-files:value`, value);
    //   if (value && value.length > 0) {
    //     let metadata = value[0];
    //     this.logger.debug('metadata: ', metadata);
    //     const { filename, content, canceled } = metadata;
    //     if (canceled) return;

    //     this.saveLastDirectory(filename)
    //     let parts = filename.split('/');
    //     this.logger.debug('content: ', content);
    //     this.form.patchValue({
    //       fileContent: content
    //     }); //.fileContent = content;
    //     // this.logger.debug('fileContent: ', that.form.value);
    //     // setTimeout(() => {
    //     //   })
    //   }
    // })
  }

  private saveLastDirectory(path: string) {
    const pathToParts = path.split('/');
    pathToParts.pop();
    let lastDir = pathToParts.join('/');
    this.settings.appDir = lastDir;
  }

}
